export default __webpack_public_path__ + "static/media/dtt-api-large.8eaa4f42.png";